import React from "react";
import { Container, Dropdown } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { ImageElement } from "../UiElement";
import logger from "../../utils/logger";
import superadminRoutesMap from "../../routeControl/superadminRoutes";
import { useDispatch, useSelector } from "react-redux";
import appNotificaton from "../../utils/notification";
import { logout, selectUserData } from "../../redux/AuthSlice/index.slice";

function SuperAdminHeader({ ToggleClass, isActive }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userData = useSelector(selectUserData);
  const accountLogout = async () => {
    try {
      appNotificaton({
        type: "success",
        message: "User Logged out",
      });
      dispatch(logout());
      navigate(superadminRoutesMap.SUPERLOGIN.path);
      // setLoading(false);
    } catch (error) {
      logger(error);
    }
    // setLoading(false);
  };
  return (
    <>
      <header className="w-100 adminHeader">
        <Container fluid>
          <div className="w-100 d-flex align-items-center justify-content-between">
            <div
              to="/#"
              className="adminHeader_click"
              onClick={() => ToggleClass()}
            >
              <em className={`${isActive ? "tripon-close" : "tripon-menu"}`} />
            </div>
            <ul className="list-unstyled mb-0 adminHeader_right">
              <li>
                <Link to="/admin/notification">
                  <em />
                </Link>
              </li>
              <li>
                <Dropdown>
                  <Dropdown.Toggle as="a">
                    <ImageElement
                      previewSource={userData?.profile_pic_url}
                      source="default-img.jpg"
                      alt="user-img"
                      isLightbox={false}
                    />
                  </Dropdown.Toggle>
                  <Dropdown.Menu as="ul">
                    <Dropdown.Item as="li">
                      <Link to="/super-admin/my-profile">My Profile</Link>
                    </Dropdown.Item>
                    <Dropdown.Item as="li">
                      <Link
                        to="/super-admin/login"
                        onClick={(e) => {
                          e.preventDefault();
                          accountLogout();
                        }}
                      >
                        Logout
                      </Link>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </li>
            </ul>
          </div>
        </Container>
      </header>
    </>
  );
}

export default SuperAdminHeader;
